import { SvgCommonProperties } from '../../common/svg.interfaces';

export default function XSvg(props: SvgCommonProperties){
  return <svg 
    height={props.height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-6 h-6"
  >
    <path d="M6 18L18 6M6 6l12 12" />
  </svg>
}